<template>
<!-- CURSOS-1135 -->
    <div style="display:none;"> <!-- quitar display:none para activar CERTIC -->
        <div style="padding: 20px;text-align:left;">
            <div class="seccion-titulo" id="contenidoPrincipal">
                 {{ $t('secretaria_virtual', {nombreApp: "CERTIC"}) }} 
            </div>   
            <div class="seccion-parrafo-nivel-1">
                {{ $t('bienv_secretariatramites', {nombreApp: "CERTIC"}) }} 
            </div> 
            <div class="seccion-parrafo-nivel-2">
                  {{ $t('bienv_tramites', {nombreApp: "CERTIC"}) }} 
            </div>    

            <div class="icono-login">
                   <Button v-bind:label="$t('acceso')" icon="fa fa-user" class="p-button-danger" @click="login" v-tooltip.top="$t('acceso')" />
            </div>   
       
        
    </div>
    </div>
</template>

<script>
import store from "../store";
import Button from "primevue/button";

export default {
    methods: {
    login() {
      this.$store.dispatch("token/revokeToken");
      let urlLogin =  store.getters["token/urlLoginCertic"];
      location.href=urlLogin;
    },
    },
    components: {
        Button,
    }, 
};
</script>